<rv-base-form-field [fieldName]="fieldName" [overrideLabel]="overrideLabel" [externalLabel]="externalLabel" [formGroup]="formGroup" [control]="control"
                    [focused]="focused" [enabled]="enabled" [hintLabel]="hintLabel" [errorLabel]="errorLabel" [subscriptSizing]="subscriptSizing"
                    [customError]="customError">
  @if (includeSearchIcon) {
    <mat-icon class="mat-icon-size-6 me-3" [ngClass]="enabled ? 'text-surface-contrast' : 'text-disabled'">search</mat-icon>
  }

  @if (includeDollarSign) {
    <span class="text-label-large me-3" [ngClass]="enabled ? 'text-surface-contrast' : 'text-disabled'">$</span>
  }

  <input matInput [type]="inputType" [formControl]="control" [placeholder]="placeholder"
         (focus)="onFocusInput()" (blur)="onBlurInput()" (keydown.enter)="onKeydownEnter()"
         [class.text-right]="alignRight"/>

  @if (postfixText) {
    <span>{{ postfixText }}</span>
  }

  @if (showClearButton) {
    <button mat-icon-button type="button" (click)="onClickClearButton()">
      @if (replaceClearButtonWithSpinner | select) {
        <mat-spinner [diameter]="24"/>
      } @else {
        <mat-icon>clear</mat-icon>
      }
    </button>
  }

  @if (showAuxiliaryButton) {
    <button mat-icon-button type="button" (click)="onClickAuxiliaryButton()">
      <mat-icon [class]="auxiliaryButtonIconClass">{{ auxiliaryButtonIconName }}</mat-icon>
    </button>
  }
</rv-base-form-field>
